/**
 * Ｗ掲載設定画面　入力VOクラス
 */
export class KYMW1310InputModel {
  /** 受注コード */
  public orderCode: string = null;
  /** Ｐコード */
  public pCode: string = null;
  /** 編集ロック(true：ロック取得、false：ロック解除) */
  public editLock: boolean = <boolean>false;
}
